import {
    NG_VALIDATORS,
    FormControl,
    ValidatorFn,
    Validator
} from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[numbervalidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: NumberValidator,
            multi: true
        }
    ]
})
export class NumberValidator implements Validator {

    validator: ValidatorFn;

    constructor() {
        this.validator = this.numberValidator();
    }

    validate(c: FormControl) {
        return this.validator(c);
    }

    numberValidator(): ValidatorFn {
        return (c: FormControl) => {
            if (c.value == undefined && c.value == null) {
                return null;
            }
            // check if string has a dot
            let hasDot: boolean = c.value.toString().includes('.');
            // convert string to number
            let number: number = Math.floor(c.value);
            // get result of isInteger()
            let integer: boolean = Number.isInteger(number);
            // validate conditions 
            let valid: boolean = !hasDot && integer && number > 0;

            if (valid) {
                return null;
            }

            return {
                numbervalidator: {
                    valid: false
                }
            }

        }
    }
}